import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01241e8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "searchbar_box" }
const _hoisted_2 = {
  key: 0,
  id: "stocks-list"
}
const _hoisted_3 = { class: "vote_top cursor" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "c_logo" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_8 = { class: "d" }
const _hoisted_9 = { class: "search_company" }
const _hoisted_10 = { class: "gray" }
const _hoisted_11 = ["disabled", "onClick"]
const _hoisted_12 = {
  key: 0,
  class: "starToggle",
  src: "/assets/icon/star_b.png"
}
const _hoisted_13 = {
  key: 1,
  class: "starToggle",
  src: "/assets/icon/star_g.png"
}
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main-info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "main-text" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "최근 본 회사")
    ])
  ])
], -1))
const _hoisted_16 = {
  key: 0,
  class: "vote_top cursor"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "c_logo" }
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_21 = { class: "d" }
const _hoisted_22 = { class: "company_title" }
const _hoisted_23 = { class: "gray" }
const _hoisted_24 = ["disabled", "onClick"]
const _hoisted_25 = {
  key: 0,
  class: "starToggle",
  src: "/assets/icon/star_b.png"
}
const _hoisted_26 = {
  key: 1,
  class: "starToggle",
  src: "/assets/icon/star_g.png"
}
const _hoisted_27 = { class: "main-info" }
const _hoisted_28 = { class: "main-text" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "인기 검색 회사", -1))
const _hoisted_30 = { class: "gray small-text" }
const _hoisted_31 = {
  key: 0,
  class: "vote_top cursor"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "c_logo" }
const _hoisted_34 = ["src"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_36 = { class: "d" }
const _hoisted_37 = { class: "company_title" }
const _hoisted_38 = { class: "gray" }
const _hoisted_39 = ["disabled", "onClick"]
const _hoisted_40 = {
  key: 0,
  class: "starToggle",
  src: "/assets/icon/star_b.png"
}
const _hoisted_41 = {
  key: 1,
  class: "starToggle",
  src: "/assets/icon/star_g.png"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sell_box" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_group_buy = _resolveComponent("group-buy")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_ion_searchbar, {
                  placeholder: "회사명, 종목(주식)코드 검색",
                  value: _ctx.searchInput,
                  debounce: "500",
                  enterkeyhint: "done",
                  onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchKeyword($event))),
                  onIonClear: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'검색영역', 'clickContent':'취소버튼'});_ctx.searchCleared($event)}),
                  onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => {_ctx.onSubmit();}, ["enter"]))
                }, null, 8, ["value"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _ctx.doRefresh
          }, null, 8, ["onRefresh"]),
          (_ctx.searchInput!=null && _ctx.reValue.displayToggle)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchStockItems, (stock) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: stock.stockItemId,
                    class: "vote_company main-deal"
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", {
                        class: "ion-activatable ripple-parent vote_top_left",
                        onClick: ($event: any) => (_ctx.selectSearchCompany(stock))
                      }, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("img", {
                            src: stock.companyLogo ? stock.companyLogo : '/assets/icon/company_default_img.png',
                            onerror: "this.src='/assets/icon/company_default_img.png'",
                            class: "img-responsive img-circle"
                          }, null, 8, _hoisted_6),
                          _hoisted_7
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, _toDisplayString(stock.stockItemName), 1),
                          _createElementVNode("span", _hoisted_10, _toDisplayString(stock.codeNumber), 1)
                        ]),
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ], 8, _hoisted_4),
                      _createElementVNode("button", {
                        class: "ion-activatable ripple-parent vote_top_right",
                        disabled: ~['mna','ipo'].indexOf(stock.companyStatus),
                        onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'검색결과', 'clickContent':`관심버튼`});(_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.itemLike(stock.stockItemId))}
                      }, [
                        (stock.likeFlag)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                          : (_openBlock(), _createElementBlock("img", _hoisted_13)),
                        _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                      ], 8, _hoisted_11)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", {
                  key: "activeClass",
                  class: _normalizeClass(_ctx.activeClass = _ctx.reValue.displayToggle ? 'none' : 'deal-toggle')
                }, [
                  _hoisted_15,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRecentStockItems, (stock) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: stock.stockItemId,
                      class: "vote_company main-deal"
                    }, [
                      stock
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("button", {
                              class: "ion-activatable ripple-parent vote_top_left",
                              onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'최근 본 회사', 'clickContent':`${stock.stockItemName}`});_ctx.useCompanyModal(stock.stockItemId)}
                            }, [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("img", {
                                  src: stock.companyLogo ? stock.companyLogo : '/assets/icon/company_default_img.png',
                                  onerror: "this.src='/assets/icon/company_default_img.png'",
                                  class: "img-responsive img-circle"
                                }, null, 8, _hoisted_19),
                                _hoisted_20
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("span", _hoisted_22, _toDisplayString(stock.stockItemName), 1),
                                _createElementVNode("span", _hoisted_23, _toDisplayString(stock.codeNumber), 1)
                              ]),
                              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                            ], 8, _hoisted_17),
                            _createElementVNode("button", {
                              class: "ion-activatable ripple-parent vote_top_right",
                              disabled: ~['mna','ipo'].indexOf(stock.companyStatus),
                              onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'최근 본 회사', 'clickContent':`관심버튼`});(_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.itemLike(stock.stockItemId))}
                            }, [
                              (stock.likeFlag)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_25))
                                : (_openBlock(), _createElementBlock("img", _hoisted_26)),
                              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                            ], 8, _hoisted_24)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ], 2),
                _createElementVNode("div", {
                  key: "activeClass",
                  class: _normalizeClass(_ctx.activeClass = _ctx.reValue.displayToggle ? 'none' : 'deal-toggle')
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.formattedNow) + " 기준", 1)
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPopularStockItems(_ctx.popularStockItem), (stock) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: stock.stockItemId,
                      class: "vote_company main-deal"
                    }, [
                      stock
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", {
                              class: "ion-activatable ripple-parent vote_top_left",
                              onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'인기 검색 회사', 'clickContent':`${stock.stockItemName}`});_ctx.useCompanyModal(stock.stockItemId)}
                            }, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("img", {
                                  src: stock.companyLogo ? stock.companyLogo : '/assets/icon/company_default_img.png',
                                  onerror: "this.src='/assets/icon/company_default_img.png'",
                                  class: "img-responsive img-circle"
                                }, null, 8, _hoisted_34),
                                _hoisted_35
                              ]),
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("span", _hoisted_37, _toDisplayString(stock.stockItemName), 1),
                                _createElementVNode("span", _hoisted_38, _toDisplayString(stock.codeNumber), 1)
                              ]),
                              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                            ], 8, _hoisted_32),
                            _createElementVNode("button", {
                              class: "ion-activatable ripple-parent vote_top_right",
                              disabled: ~['mna','ipo'].indexOf(stock.companyStatus),
                              onClick: ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen, 'clickArea':'인기 검색 회사', 'clickContent':`관심버튼`});(_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.itemLike(stock.stockItemId))}
                            }, [
                              (stock.likeFlag)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_40))
                                : (_openBlock(), _createElementBlock("img", _hoisted_41)),
                              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                            ], 8, _hoisted_39)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ], 2),
                _hoisted_42,
                _createVNode(_component_group_buy, { parent: "search" })
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}